module.exports = __webpack_public_path__ + "website/img/print1-1.186ea564.png";